// FinTrack — Navigation, page switching, data loading
import { state, ALL_TABS } from './state.js';
import { sb } from './supabase.js';
import { toast, showLoading, hideLoading } from './ui.js';

// Module render function registry — populated by main.js to avoid circular imports
const renderers = {};
export function registerRenderer(name, fn) { renderers[name] = fn; }

// Track unsaved data state
let hasUnsavedData = false;
export function setUnsavedData(val) { hasUnsavedData = val; }

// Warn before leaving with unsaved data
window.addEventListener('beforeunload', (e) => {
  if (hasUnsavedData) {
    e.preventDefault();
    e.returnValue = '';
  }
});

export function showApp() {
  document.getElementById('authOverlay').classList.add('hidden');
  document.getElementById('app').style.display = 'flex';
  document.getElementById('uDisp').textContent = state.CU.full_name;
  const rd = document.getElementById('rDisp');
  rd.textContent = state.CU.role.toUpperCase();
  if (state.CU.role === 'superadmin') rd.classList.add('sa'); else rd.classList.remove('sa');
  const _now = new Date();
  const _fmt = d => String(d.getDate()).padStart(2,'0') + '.' + String(d.getMonth()+1).padStart(2,'0') + '.' + d.getFullYear();
  // Nedeljni: "Do" = petak tekuće nedelje (day 5=Fri)
  const _fri = new Date(_now);
  const _dow = _fri.getDay(); // 0=Sun
  const _daysToFri = _dow <= 5 ? (5 - _dow) : (5 + 7 - _dow);
  _fri.setDate(_fri.getDate() + _daysToFri);
  document.getElementById('dtTo').value = _fmt(_fri);
  document.getElementById('dtToK').value = _fmt(_now);
  buildNav();
  loadAllData();
}

export function buildNav() {
  const nav = document.getElementById('navTabs');
  nav.textContent = '';
  const tabs = state.CU.allowed_tabs || ['izvestaj'];
  ALL_TABS.forEach(t => {
    // Sekcija header — klikabilna sa expand/collapse
    if (t.section) {
      const sec = document.createElement('div');
      sec.className = 'sb-section';
      sec.dataset.section = t.id;
      // SVG ikonica za sekciju
      const secIcon = document.createElement('span');
      secIcon.className = 'sb-icon';
      secIcon.style.cssText = 'opacity:.5;margin-right:6px';
      const tmpl = document.createElement('template');
      if (t.id === '_sec_izvestaji') tmpl.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>';
      else tmpl.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/></svg>';
      secIcon.appendChild(tmpl.content);
      const secLabel = document.createElement('span'); secLabel.textContent = t.label;
      const chevron = document.createElement('span');
      chevron.className = 'sb-sec-chev';
      chevron.textContent = '\u25BC';
      sec.appendChild(secIcon); sec.appendChild(secLabel); sec.appendChild(chevron);
      // Kontejner za stavke sekcije
      const secItems = document.createElement('div');
      secItems.className = 'sb-sec-items';
      secItems.id = 'sec-items-' + t.id;
      sec.onclick = () => {
        secItems.classList.toggle('collapsed');
        chevron.textContent = secItems.classList.contains('collapsed') ? '\u25B6' : '\u25BC';
      };
      nav.appendChild(sec);
      nav.appendChild(secItems);
      return;
    }
    if (!tabs.includes(t.id) && state.CU.role !== 'superadmin') return;
    const b = document.createElement('button');
    b.id = 'tab-' + t.id;
    if (t.icon) {
      const iconSpan = document.createElement('span');
      iconSpan.className = 'sb-icon';
      const tmpl = document.createElement('template');
      tmpl.innerHTML = t.icon;
      iconSpan.appendChild(tmpl.content);
      b.appendChild(iconSpan);
    }
    const labelSpan = document.createElement('span');
    labelSpan.textContent = t.label;
    b.appendChild(labelSpan);
    b.onclick = () => showPage(t.id);
    // Dodaj u poslednji sekcija kontejner, ili direktno u nav
    const allContainers = nav.querySelectorAll('.sb-sec-items');
    const lastContainer = allContainers.length ? allContainers[allContainers.length - 1] : null;
    const standalone = ['dashboard', 'kurs', 'users', 'istorija'];
    if (lastContainer && !standalone.includes(t.id)) {
      lastContainer.appendChild(b);
    } else {
      nav.appendChild(b);
    }
  });
  // Odredi početnu stranicu iz URL-a ili default
  const urlPage = window.location.pathname.replace('/', '');
  const validPage = ALL_TABS.find(t => t.id === urlPage);
  const first = validPage ? urlPage : (state.CU.role === 'superadmin' ? ALL_TABS[0].id : tabs[0] || 'izvestaj');
  showPage(first, false);
}

// Browser back/forward navigacija
window.addEventListener('popstate', (e) => {
  const p = e.state?.page || window.location.pathname.replace('/', '') || 'dashboard';
  if (state.CU) showPage(p, false);
});

export function showPage(p, pushState = true) {
  // Route guard: check tab permissions
  if (state.CU && state.CU.role !== 'superadmin') {
    const tabs = state.CU.allowed_tabs || [];
    if (tabs.length && !tabs.includes(p) && p !== 'dashboard') return;
  }
  document.querySelectorAll('.pg').forEach(el => el.classList.remove('active'));
  document.querySelectorAll('.sb-nav button, .tnav button').forEach(el => el.classList.remove('active'));
  const pg = document.getElementById('pg-' + p); if (pg) pg.classList.add('active');
  const tb = document.getElementById('tab-' + p); if (tb) tb.classList.add('active');

  // Close mobile sidebar on page change
  const sidebar = document.getElementById('sidebar');
  if (sidebar) sidebar.classList.remove('mobile-open');

  // URL routing
  if (pushState && window.history.pushState) {
    const url = '/' + p;
    if (window.location.pathname !== url) window.history.pushState({ page: p }, '', url);
  }
  document.title = 'SBIS \u2014 ' + (ALL_TABS.find(t => t.id === p)?.label || p);

  // Breadcrumb
  const bcEl = document.getElementById('bcPage');
  if (bcEl) {
    const t = ALL_TABS.find(t => t.id === p);
    bcEl.textContent = t ? t.label : p;
  }

  // Call registered renderers
  if (p === 'dashboard') { renderers.loadHistory?.(); renderers.renderDashboard?.(); }
  if (p === 'users') renderers.renderUsers?.();
  if (p === 'komitenti') renderers.renderKom?.();
  if (p === 'troskovi') renderers.renderVrste?.();
  if (p === 'istorija') renderers.loadHistory?.();
  if (p === 'kontni-plan') renderers.renderKontniPlan?.();
  if (p === 'knjizenja') renderers.updateKjBtnState?.();
  if (p === 'komitenti-full') renderers.loadKomitentiFull?.();
  if (p === 'pocetno-stanje') renderers.loadPocetnoStanje?.();
  if (p === 'zakljucni-list') renderers.loadZakljucniList?.();
  if (p === 'kurs') renderers.loadKursPage?.();
}

export async function loadAllData() {
  try {
    showLoading();
    const [vr, kr] = await Promise.all([
      sb.from('vrste_troskova').select('*').is('deleted_at', null).order('sort_order'),
      sb.from('komitenti').select('*, vrste_troskova(name_en,name_sr,icon)').is('deleted_at', null).order('name')
    ]);
    if (vr.error) throw vr.error;
    if (kr.error) throw kr.error;
    state.vrsteData = vr.data || [];
    state.komData = kr.data || [];
    if (state.CU.role === 'superadmin') {
      try {
        const { data, error } = await sb.rpc('list_users', { p_caller_id: state.CU.id });
        if (error) throw error;
        state.usersData = data || [];
      } catch (e) {
        toast('Greška pri učitavanju korisnika: ' + e.message, 'err');
        state.usersData = [];
      }
    }
    renderers.renderKom?.();
    renderers.renderVrste?.();
    // Ucitaj kontni plan iz baze
    renderers.loadKontniPlan?.();
    hideLoading();
  } catch (e) {
    hideLoading();
    toast('Greška pri učitavanju podataka: ' + (e.message || 'Proverite internet konekciju'), 'err');
  }
}

export function startKeepAlive() {
  const PING_INTERVAL = 6 * 60 * 60 * 1000; // 6h
  async function ping() { try { await sb.rpc('health_check'); } catch (e) {} }
  // Ping odmah pri ucitavanju
  ping();
  // Ponavljaj svakih 6h
  setInterval(ping, PING_INTERVAL);
}

export function applyDatePreset(val, fromId, toId) {
  if (!val) return;
  const now = new Date(); const y = now.getFullYear(); const m = now.getMonth();
  let from, to;
  if (val === 'thisMonth') { from = new Date(y, m, 1); to = new Date(y, m + 1, 0); }
  else if (val === 'lastMonth') { from = new Date(y, m - 1, 1); to = new Date(y, m, 0); }
  else if (val === 'thisQ') { const q = Math.floor(m / 3) * 3; from = new Date(y, q, 1); to = new Date(y, q + 3, 0); }
  else if (val === 'lastQ') { const q = Math.floor(m / 3) * 3 - 3; from = new Date(y, q, 1); to = new Date(y, q + 3, 0); }
  else if (val === 'thisYear') { from = new Date(y, 0, 1); to = new Date(y, 11, 31); }
  else if (val === 'lastYear') { from = new Date(y - 1, 0, 1); to = new Date(y - 1, 11, 31); }
  if (from && to) {
    const _fmt = d => String(d.getDate()).padStart(2,'0') + '.' + String(d.getMonth()+1).padStart(2,'0') + '.' + d.getFullYear();
    document.getElementById(fromId).value = _fmt(from);
    document.getElementById(toId).value = _fmt(to);
  }
}

export async function fetchAutoKurs(inputId) {
  const inp = document.getElementById(inputId); if (!inp) return;
  const origVal = inp.value;
  inp.value = '...'; inp.disabled = true;
  try {
    const resp = await fetch('/api/exchange-rate');
    const data = await resp.json();
    if (data.success && data.rates.USD_RSD) {
      inp.value = data.rates.USD_RSD.toFixed(2);
      toast('Kurs ažuriran: 1 USD = ' + data.rates.USD_RSD.toFixed(2) + ' RSD (' + data.source + ')');
    } else {
      inp.value = origVal; toast('Nije moguće preuzeti kurs', 'err');
    }
  } catch (e) { inp.value = origVal; toast('Greška pri preuzimanju kursa', 'err'); }
  inp.disabled = false;
}

// toggleRepKurs removed — always show kurs input (RSD+USD)
